import { render } from "./ContactsEntityOverview.vue?vue&type=template&id=31573113"
import script from "./ContactsEntityOverview.vue?vue&type=script&lang=js"
export * from "./ContactsEntityOverview.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__